<script setup>
    import { ref, computed } from 'vue';
    import { useLayout } from '@/layout/composables/layout';
    import Menu from 'primevue/menu';
    import Store from '../store';
    import Router from '../router'
    import api from '../lib/serverApi';
    import dialogs from '../lib/dialogs';

    const topbarMenuActive = ref(false);

    const { layoutConfig , onMenuToggle, layoutState } = useLayout();

    const menu = ref();
    const userMenuItems = ref([
            {
                label: 'Настройки',
                icon: 'pi pi-cog',
                command: onSettingsClick
            },
            {
                label: 'Скачать приложение Android',
                icon: 'pi pi-cloud-download',
                command: onDownloadAndroidApp
            },
            {
                label: 'Выход',
                icon: 'pi pi-sign-out',
                command: logOff
            }
        ]
    );

    const logoUrl = computed(() => {
        return `/layout/images/${layoutConfig.darkTheme.value ? 'logo-white' : 'logo-dark'}.svg`;
    });

    const currentFormHeader = computed(() => {
        return Store.getters.currentFormHeader;
    });

    const topbarMenuClasses = computed(() => {
        return {
            'layout-topbar-menu-mobile-active': topbarMenuActive.value
        };
    });

    const userName = computed(() => {
        return Store.getters.userVisualData.displayName;
    });

    function onTopBarMenuButton() {
        topbarMenuActive.value = !topbarMenuActive.value;
    }

    function onSettingsClick() {
        topbarMenuActive.value = false;
        layoutState.settingsMenuActive.value = true;
    }

    function toggle (event) {
        menu.value.toggle(event);
    }

    async function logOff() {
        const res = await dialogs.confirmDialog('Вы уверены что хотите выйти из системы?');
        if (!res) return;

        try {
            await api.logoff();
        } catch (error) {
            //
        }
        Store.commit('CLEAR_USER');
        Router.push('/Login');
    }

    function onDownloadAndroidApp() {
        let link = document.createElement('a');
        link.setAttribute('href', 'upload/ESASmarthomeAndroid.apk');
        link.setAttribute('download', 'ESASmarthomeAndroid.apk');
        link.click();
    }
</script>

<template>
    <div class="layout-topbar">

        <div class="layout-topbar-logo pl-2">
            <img :src="logoUrl" alt="logo" />
            <span>Мой умный дом</span>
        </div>

        <button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>

        <button class="p-link layout-topbar-menu-button layout-topbar-button" @click="onTopBarMenuButton()">
            <i class="pi pi-ellipsis-v"></i>
        </button>

        <span class="layout-topbar-current-menu">{{ currentFormHeader }}</span>

        <div class="layout-topbar-menu" :class="topbarMenuClasses">
            <button class="p-link layout-topbar-button">
                <i class="pi pi-bell"></i>
                <span>Оповщения</span>
            </button>

            <button class="p-link layout-topbar-button"
                @click="toggle"
                aria-haspopup="true"
                aria-controls="overlay_menu"
                v-tooltip.left="userName"
            >
                <img src="/noname.png" alt="Image" height="25" shape="circle"/>
                <span>{{ userName }}</span>
            </button>

            <Menu ref="menu" id="overlay_menu" :model="userMenuItems" :popup="true" style="width: 20rem" />
        </div>
    </div>
</template>

<style lang="scss" scoped></style>
